import React from "react";

import { DataTableFilter } from "components/ui/DataTable/components/DataTableFilter/DataTableFilter";
import { DataTableSearch } from "components/ui/DataTable/components/DataTableSearch/DataTableSearch";
import { DataTableSort } from "components/ui/DataTable/components/DataTableSort/DataTableSort";

import styles from "./DataTableToolbar.module.css";

export const DataTableToolbar = ({
  search,
  filters,
  filtersConfig,
  sort,
  sortOptions,
  onSortChange,
  onFilterChange,
  topActions = [],
  toolbarExtra,
}) => {
  return (
    <div className={styles.toolbar}>
      <div className={styles.toolbarLeft}>
        {search && (
          <DataTableSearch
            value={search.value ?? search}
            onChange={search.onChange ?? search.onSearchChange}
            placeholder={search.placeholder ?? "Search"}
            maxWidth={search.maxWidth}
          />
        )}
        <DataTableFilter
          filters={filters}
          filtersConfig={filtersConfig ?? []}
          onChange={filters?.onChange ?? onFilterChange}
        />
        {toolbarExtra}
      </div>
      <div className={styles.toolbarRight}>
        <DataTableSort
          sort={sort}
          sortOptions={sortOptions ?? []}
          onSortChange={sort?.onChange ?? onSortChange}
        />
        {topActions?.length > 0 && (
        <div className={styles.topActions}>
          {topActions.map((action, i) =>
            action.href ? (
              <a
                key={i}
                href={action.href}
                className={styles.topActionLink}
                onClick={(e) => action.onClick?.(e) && e.preventDefault()}
              >
                {action.label}
              </a>
            ) : (
              <button
                key={i}
                type="button"
                className={styles.topActionButton}
                onClick={() => action.onClick?.()}
              >
                {action.label}
                {!!action.icon && <action.icon size={16} />}
              </button>
            )
          )}
        </div>
      )}
      </div>
    </div>
  );
};
